export default __webpack_public_path__ + "static/media/MoodScream.fab8a122.png";